// Replaces new lines with spaces and trims beginning and end
export const textareaStripper = (string: string) => {
  return string.replace(/(\r\n|\n|\r|\\n)/gm, ' ').trim();
};
